<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19qxDAi/tc-custom/9781504093132.jpg?1737543861965" alt="This image is the cover for the book Haunting Hand, Otto Penzler's Locked Room Library"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Haunting Hand, Otto Penzler's Locked Room Library
      </h1>
      <p class="bookDescription body article font2">
        <b>An actress stars in her own off-screen mystery in this Golden Age whodunit from the award-winning Jamaican novelist, poet, and historian.</b><br/>  <br/> Though originally a medical student specializing in chemistry, twenty-five-year-old Margot Anstruther decides to try her luck as an actress and gets cast in her first role for the Superfilm Company. With the studio’s boorish director taking a personal interest in her, Margot finds herself caught in the middle of two men: her boss and her increasingly jealous suitor, Gene Varley.<br/>  <br/> One night, alone in her midtown Manhattan apartment after a party, Margot is shocked to find a hand reaching out from under her bed. Though Gene and the police find no sign of an intruder, Margot refuses to believe in a supernatural cause. She puts her scientific mind to work delving into her apartment’s strange past—a recent tenants’ disappearance—and walking a fine line between the complicated passions of friends and rivals . . .<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        W. Adolphe Roberts
      </h2>
      
      <p class="authorDescription body article">W. Adolphe Roberts was a Jamaican-born novelist, poet, and historian. Roberts served as a war correspondent during World War I, after which he acted as the editor of multiple periodicals including <I>Ainslee&rsquo;s Magazine</I>, and authored more than a dozen books. He died in 1962.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MysteriousPress.com/Open Road Integrated Media, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c704057c